"use client";

import * as React from 'react';
import { cn } from '@/lib/utils/cn';

const VisuallyHidden = React.forwardRef<
  HTMLSpanElement,
  React.ComponentPropsWithoutRef<'span'>
>(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      'sr-only absolute h-px w-px overflow-hidden whitespace-nowrap border-0 p-0 [-webkit-clip-path:inset(50%)] [clip:rect(0,0,0,0)] [clip-path:inset(50%)]',
      className,
    )}
    {...props}
  />
));
VisuallyHidden.displayName = 'VisuallyHidden';

export { VisuallyHidden };
